module.exports = "/_next/static/images/bc67b328a6ba0dcc6cc2edb5104b0b03-man-looking-up-smiling-lg@1x.jpg";